// extracted by mini-css-extract-plugin
export default {"audioContainer":"AudioPreview_audioContainer__SU5Sl","audioImage":"AudioPreview_audioImage__RZCcr","playButton":"AudioPreview_playButton__GrrGr"};